import { APP_CONFIG } from '@/constants/config';

function stripTrailingSlash(url) {
  return typeof url === 'string' ? url.replace(/\/+$/, '') : url;
}

// Frontend origin used to build redirect URLs (e.g. the online session's complete_url/exit_url).
export const APP_BASE_URL = stripTrailingSlash(APP_CONFIG.APP_BASE_URL);

export const IMAGE_BASE_DOMAIN = APP_CONFIG.IMAGE_BASE_URL;

export const SERVER_BASE_URL = APP_CONFIG.API_BASE_URL;

export const API_BASE_URL = APP_CONFIG.API_BASE_URL;

// Environments without a reCAPTCHA site key (currently only dev) skip reCAPTCHA in auth flows.
export const SKIP_RECAPTCHA = !APP_CONFIG.SITE_KEY;
